export const CONSTS = {
  ORIGIN_DETAILS: $localize`Origin Details`,
  DESTINATION_DETAILS: $localize`Destination Details`,
};
